import accordions from './accordions'

export default accordions



// WEBPACK FOOTER //
// ./reducers/application/workspaces-sources-integrations/index.js